import { ModuleWithProviders } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

export const appRoutes: Routes = [
    {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
    {path: '**', redirectTo: 'not-found', pathMatch: 'full'},
];

export const APP_ROUTING: ModuleWithProviders<RouterModule> = RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' });
